var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 1.66675C5.39175 1.66675 1.66675 5.39175 1.66675 10.0001C1.66675 14.6084 5.39175 18.3334 10.0001 18.3334C14.6084 18.3334 18.3334 14.6084 18.3334 10.0001C18.3334 5.39175 14.6084 1.66675 10.0001 1.66675ZM14.1667 12.9917L12.9917 14.1667L10.0001 11.1751L7.00841 14.1667L5.83342 12.9917L8.82508 10.0001L5.83342 7.00841L7.00841 5.83342L10.0001 8.82508L12.9917 5.83342L14.1667 7.00841L11.1751 10.0001L14.1667 12.9917Z",
    fill: "#C9D1CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 1.66675C5.39175 1.66675 1.66675 5.39175 1.66675 10.0001C1.66675 14.6084 5.39175 18.3334 10.0001 18.3334C14.6084 18.3334 18.3334 14.6084 18.3334 10.0001C18.3334 5.39175 14.6084 1.66675 10.0001 1.66675ZM14.1667 12.9917L12.9917 14.1667L10.0001 11.1751L7.00841 14.1667L5.83342 12.9917L8.82508 10.0001L5.83342 7.00841L7.00841 5.83342L10.0001 8.82508L12.9917 5.83342L14.1667 7.00841L11.1751 10.0001L14.1667 12.9917Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFilterIcon);
export default __webpack_public_path__ + "static/media/clearFilterIcon.e18e31cf15b7cee8230916ec18078af9.svg";
export { ForwardRef as ReactComponent };